import { render, staticRenderFns } from "./customerDesk.vue?vue&type=template&id=31d83c12&scoped=true&"
import script from "./customerDesk.vue?vue&type=script&lang=js&"
export * from "./customerDesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d83c12",
  null
  
)

export default component.exports